import { BreadCrumb } from '../components/common'
import Header from './header'
// import SideNav from './sidenav'
import Footer from './footer'
// import { useAuthStore } from '../store/authStore'

export default function Layout({ children }: any) {
  // const { authenticated } = useAuthStore()

  return (
    <div className="flex  dark:bg-gray-700 dark:text-gray-100">
      {/* {authenticated && (
        <div className="relative" style={{ width: 'calc(16rem + 24px)' }}>
          <SideNav />
        </div>
      )} */}

      <div className="flex-1 flex flex-col h-full w-full overflow-hidden">
        {/* Header */}
        <div className="absolute top-0 left-0 w-full z-10">
          <Header />
        </div>

        {/* Main Content */}
        <div className="flex-1 flex flex-col overflow-hidden pt-[167px] lg:pt-[180px]">
          <main className="dark:bg-gray-700 dark:text-gray-100 lg:px-0 flex flex-col flex-1 overflow-x-hidden overflow-y-auto no-scrollbar">
            <BreadCrumb />
            {children}
          </main>
        </div>

        {/* Footer */}
        <div className="">
          <Footer />
        </div>
      </div>
    </div>
  )
}
